import { Scoring } from '../interfaces';

const range = (start: number, end: number, step: number = 1) => {
	const length = (Math.max(start, end) - Math.min(start, end)) / Math.abs(step);
	return Array.from({ length }, (_, i) => start + i * step);
};

const trimDomain = (val: number) => {
	return Math.min(Math.max(val, 0.0), 6.0);
};

function calcScale(score: number, cut: number, SEM: number) {
	// ranges are constant -- should be in scoring dict
	const ranges = [...range(7, -1, -1).map((n) => cut - n * SEM), 161];
	// scaled values are also constant, so should not be re-calc'd
	const scaledVals = range(120, 210, 10);

	// if score is out of range, force it into range
	// (really can't happen, but...)
	score = Math.min(Math.max(score, 0), 160);

	for (let idx = 0; idx < ranges.length; ++idx) {
		const n = ranges[idx];
		if (score < n) {
			return scaledVals[idx];
		}
	}

	return 120;
}

export function scoreExam(
	exam: string,
	rawscores: { [key: string]: number },
	scoreKeys: string[],
	scoring: Scoring
): { [key: string]: number } {
	const stats = scoring[exam.toUpperCase()];
	const results: { [key: string]: number } = {
		scaled: calcScale(rawscores.score, stats.cut, stats.SEM)
	};

	for (const sub of scoreKeys) {
		const raw = rawscores[sub];
		const cut = stats.domainCut[sub];
		const SEM = stats.domainSEM[sub];
		results[sub] = trimDomain((raw - cut) / SEM + 3);
	}
	return results;
}
